import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-content">
        <div className="site-footer-links">
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <a href="mailto:support@companysieve.com">Contact</a>
        </div>
        <p className="site-footer-copy">
          &copy; {new Date().getFullYear()} CompanySieve, LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
